export default "__VITE_ASSET__D7BImU9h__"